// Shared bits for the BSCR workspace.
import Pill from "@/components/Pill";

export const SPECIAL = new Set(["B", "S", "T", "V", "W"]);

export const FIELD_STATUS_TONE = {
    "Auto-populated": "blue", "Manually entered": "neutral", "Missing / TBC": "amber",
    "Not applicable": "neutral", "Needs review": "purple", "Approved": "green",
};
export const SECTION_STATUS_TONE = {
    "Not started": "neutral", "In progress": "amber", "Needs review": "purple",
    "Approved": "green", "Not applicable": "neutral",
};
export const RECORD_STATUS_TONE = {
    Draft: "neutral", "In progress": "amber", "Awaiting information": "amber",
    "Ready for review": "blue", "Under review": "purple", "Changes required": "red",
    Approved: "green", Issued: "green", Archived: "neutral",
    // legacy
    "In review": "amber", Submitted: "blue", Accepted: "green", Rejected: "red",
};
export const RATING_TONE = {
    Intolerable: "red", Substantial: "red", Moderate: "amber", Tolerable: "green",
};
export const RATING_COLOR = {
    Intolerable: "#B33A2E", Substantial: "#D9772E", Moderate: "#C68A1C", Tolerable: "#3F7D3A",
};

export const inputCls = "w-full px-3 py-2 rounded-lg border border-[#E5E0DA] bg-white text-[13px] text-[#1F1F1F] outline-none focus:border-[var(--brand-accent,#C75A1B)] focus:ring-2 focus:ring-[#FBEFE5]";

export function StatusDot({ status }) {
    const c = { Approved: "#3F7D3A", "In progress": "#C68A1C", "Needs review": "#6B4E9E",
        "Not applicable": "#C0BBB3", "Not started": "#D5CEC6" }[status] || "#D5CEC6";
    return <span className="inline-block w-2 h-2 rounded-full shrink-0" style={{ background: c }} />;
}

export function SectionPill({ status }) {
    return <Pill tone={SECTION_STATUS_TONE[status] || "neutral"}>{status}</Pill>;
}
